"use strict";

exports.__esModule = true;
exports.default = void 0;
var _trackers = require("../trackers");
var gaListener = function gaListener(event, data) {
  if (event === 'pageview') {
    _trackers.ga.trackPageview(data);
  } else {
    _trackers.ga.trackEvent(Object.assign({
      eventAction: event,
      eventCategory: '(Not set)'
    }, data));
  }
};
var _default = exports.default = gaListener;